import React, { useState } from "react";
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import MicOutlinedIcon from '@mui/icons-material/MicOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import HistoryIcon from '@mui/icons-material/History';
import RoomIcon from '@mui/icons-material/Room';
import Box from "@mui/material/Box";
import GameRules from "./GameRules";
import SpecialCases from "./SpecialCases.jsx";
import PrivateQuestion from "./PrivateQuestion.jsx";
import Historics from "./Historics.jsx";

export const HelpComponent = ({onClose, gameData, gameId, socket, historics}) => {
    const [activeDetail, setActiveDetail] = useState(null); // e.g., 'rules'

    const cards = [
        {key: 'rules', label: 'Règles du jeu', Icon: MenuBookOutlinedIcon, disabled: false},
        {key: 'public', label: 'Question publique', Icon: MicOutlinedIcon, disabled: true},
        {key: 'private', label: 'Question privée', Icon: ChatBubbleOutlineOutlinedIcon, disabled: false},
        // {key: 'historics', label: 'Historique de la partie', Icon: HistoryIcon, disabled: false},
    ];

    if (gameData && gameData.specialCases && gameData.specialCases.length > 0) {
        cards.push({key: 'special', label: 'Case spéciales', Icon: RoomIcon, disabled: false});
    }

    const renderCard = ({key, label, Icon, disabled}) => (
        <button
            key={key}
            aria-label={label}
            aria-disabled={disabled}
            onClick={() => {
                if (!disabled) {
                    if (key === 'rules') setActiveDetail('rules');
                    if (key === 'special') setActiveDetail('special');
                    if (key === 'private') setActiveDetail('private');
                    if (key === 'historics') setActiveDetail('historics');
                    // ...other cards could open their own detail views later
                }
            }}
            style={{
                position: 'relative',
                width: '100%',
                // 3:2 aspect using padding-top technique (height = 2/3 of width)
                paddingTop: '66.6667%',
                border: 'none',
                borderRadius: 14,
                background: disabled ? 'rgba(255,255,255,0.08)' : 'linear-gradient(180deg, rgba(255,255,255,0.08), rgba(255,255,255,0.03))',
                boxShadow: disabled ? 'none' : '0 6px 18px rgba(0,0,0,0.25)',
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.5 : 1,
                overflow: 'hidden'
            }}
        >
            {/* Icon top-right, 33% of card */}
            <div style={{
                position: 'absolute',
                top: 10,
                left: 10,
                width: '25%',
                height: '33%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                color: '#ffffff'
            }}>
                <Icon style={{width: '80%', height: '80%'}}/>
            </div>
            {/* Title bottom-left */}
            <div style={{
                position: 'absolute',
                left: 12,
                bottom: 12,
                right: 12,
                color: '#ffffff',
                fontWeight: 700,
                fontSize: 16,
                textAlign: 'left',
                lineHeight: 1.2
            }}>
                {label}
            </div>
        </button>
    );

    return (
        <Box sx={{width: {xs: "100%", md: "50%", lg: "33%"}, margin: "0 auto", background: "none"}}>
            <div style={{
                width: "100%",
                height: "100%",
                boxSizing: "border-box",
                padding: 20,
                display: "flex",
                flexDirection: "column",
                color: "#fff",
                background: "linear-gradient(180deg, #1b1f3a 0%, #111325 100%)"
            }}>
                {/* Header hidden when in detail view */}
                {!activeDetail && (
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: 12
                    }}>
                        <div style={{fontSize: 20, fontWeight: 700}}>Aide</div>
                        <button
                            aria-label="Close help"
                            onClick={onClose}
                            style={{
                                background: "transparent",
                                color: "#fff",
                                border: "none",
                                fontSize: 28,
                                lineHeight: 1,
                                cursor: "pointer"
                            }}
                        >
                            ×
                        </button>
                    </div>
                )}

                {/* Content: either detail view or cards grid */}
                {activeDetail === 'rules' ? (
                    <GameRules rules={gameData.rules} onBack={() => setActiveDetail(null)} />
                ) : activeDetail === 'special' ? (
                    <SpecialCases gameId={gameId} specialCases={gameData.specialCases} onBack={() => setActiveDetail(null)} />
                ) : activeDetail === 'private' ? (
                    <PrivateQuestion socket={socket} onBack={() => setActiveDetail(null)} />
                ) : activeDetail === 'historics' ? (
                    <Historics historics={historics} onBack={() => setActiveDetail(null)} />
                ) : (
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: "4px 12px"
                    }}>
                        {cards.map(renderCard)}
                    </div>
                )}
            </div>
        </Box>
    );
};

export default HelpComponent;
